import { useCallback, useEffect, useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'

import { CompanyContext } from '../../Store/CompanyContext'

import { signinDemo } from '../../API/Login/login'

export default function LoginDemo() {
	const { actions } = useContext(CompanyContext)
	const [language, setLanguage] = useState('')
	const history = useHistory()

	const handleLogin = useCallback(async () => {
		try {
			const auth = await signinDemo()

			localStorage.setItem('token', auth.token)
			localStorage.setItem('user', JSON.stringify(auth.response))

			actions.setLogin(auth.response)

			history.push('/app')
		} catch {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Algo salió mal !',
			})
		}
	}, [])

	useEffect(() => {
		handleLogin()
	}, [handleLogin])

	useEffect(() => {
		const navigatorLanguage = navigator.language || navigator.userLanguage
		setLanguage(navigatorLanguage)
	}, [])

	return (
		<div className='tw-w-screen tw-h-screen tw-flex tw-items-center tw-justify-center'>
			{language === 'pt-BR' ? (
				<div>
					<h1>Estamos quase lá!</h1>
					<p>Estamos finalizando a configuração da sua versão de teste. Em instantes, tudo estará pronto para você começar.</p>
				</div>
			) : (
				<div>
					<h1>Estamos casi listos!</h1>
					<p>Estamos finalizando la configuración de tu versión de prueba. En instantes, todo estará listo para que puedas comenzar.</p>
				</div>
			)}
		</div>
	)
}
